import React from 'react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  return <motion.section initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="w-full max-w-4xl mx-auto my-16 px-4" data-id="element-129">
      <div className="bg-cream-dark rounded-2xl p-6 md:p-10 border border-brown-light/20 shadow-sm flex flex-col md:flex-row gap-8 items-center" data-id="element-130">
        <div className="w-full md:w-1/2" data-id="element-131">
          <div className="aspect-square bg-cream rounded-xl border-2 border-white shadow-inner flex items-center justify-center overflow-hidden relative" data-id="element-132">
            <img src="https://cdn.magicpatterns.com/uploads/hZmNvwDCJSJgP1i3HUsLod/Magen_Darm_4f46689c-206a-426f-9344-0505df3c965a.webp" alt="Hunderunde Futtertopping Magen & Darm" className="w-full h-full object-contain p-4" data-id="element-133" />
          </div>
        </div>

        <div className="w-full md:w-1/2 space-y-4" data-id="element-134">
          <h3 className="font-handwriting text-4xl text-forest" data-id="element-135">
            Was ich bestellt habe
          </h3>
          <p className="font-serif text-lg text-brown-dark/90 leading-relaxed" data-id="element-136">
            Ich habe mich bewusst gegen weitere chemische Präparate entschieden
            und stattdessen das natürliche Magen-Darm-Topping von Hunderunde
            gewählt. Es enthält genau die pflanzlichen Inhaltsstoffe, die Balus
            gereizten Darm auf sanfte Weise wieder ins Gleichgewicht bringen.
          </p>
        </div>
      </div>
    </motion.section>;
}